<ng-container></ng-container>


// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/tracking/synthetic-performance-tracking.component.ts.SyntheticPerformanceTrackingComponent.html